function saveFile(blob, name) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function downloadFiles(files, archiveName = "inspection-reports.zip") {
  if (!files.length) throw new Error("Inspection report files are not available for this vehicle.");
  const usedNames = new Set();
  const downloads = await Promise.all(files.map(async (file, index) => {
    // The storage host does not let a script read its files; the API serves
    // the same file in a way that can be fetched. The name still comes from
    // the file's own link.
    const response = await fetch(file.api_url || file.url);
    if (!response.ok) throw new Error("Unable to download the inspection report. Please try again.");
    let name = file.file_name || file.display_name || decodeURIComponent(new URL(file.url, window.location.href).pathname.split("/").pop()) || `report-${index + 1}`;
    name = Array.from(name, char => char.charCodeAt(0) < 32 ? "-" : char).join("").replace(/[\\/:*?"<>|]/g, "-");
    const original = name;
    let suffix = 2;
    while (usedNames.has(name)) {
      const dot = original.lastIndexOf(".");
      name = dot > 0 ? `${original.slice(0, dot)}-${suffix}${original.slice(dot)}` : `${original}-${suffix}`;
      suffix += 1;
    }
    usedNames.add(name);
    return { name, blob: await response.blob() };
  }));
  if (downloads.length === 1) {
    saveFile(downloads[0].blob, downloads[0].name);
    return;
  }
  const { default: JSZip } = await import("jszip");
  const zip = new JSZip();
  downloads.forEach(({ name, blob }) => zip.file(name, blob));
  saveFile(await zip.generateAsync({ type: "blob" }), archiveName);
}
